import PersonalInformationForm from './PersonalInformationForm'
import './index.css'

const Profile = () => {
    return <PersonalInformationForm />
}

export default Profile
